export default __webpack_public_path__ + "static/media/icon_finishingtype_Scalloped.d5520200.png";